if (typeof OliveShippingBar !== 'function') {

  const STORAGE_KEY = 'oliveBarProgress';

  class OliveShippingBar extends HTMLElement {

    connectedCallback() {
      this.update();
    }

    update() {
      const threshold = Number(this.dataset.threshold);
      const total = Number(this.dataset.cartTotal);

      if (!threshold || threshold <= 0) {
        this.style.display = 'none';
        return;
      }

      const remaining = threshold - total;
      const progress = Math.max(0, Math.min(100, (total / threshold) * 100));

      const fill = this.querySelector('.olive-shipping-bar__fill');
      const message = this.querySelector('.olive-shipping-bar__message');

      if (fill) {
        let prev = 0;
        try { prev = parseFloat(sessionStorage.getItem(STORAGE_KEY)) || 0; } catch (e) {}

        fill.style.transition = 'none';
        fill.style.width = prev + '%';
        void fill.offsetWidth;
        fill.style.transition = '';

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            fill.style.width = progress + '%';
          });
        });

        try { sessionStorage.setItem(STORAGE_KEY, String(progress)); } catch (e) {}
      }

      const remainingText = this._formatMoney(Math.max(0, remaining));
      const successText = this.dataset.successText || 'Glückwunsch — du erhältst kostenfreien Versand!';
      const rawTemplate = this.dataset.progressText || 'Nur noch {amount} bis zum kostenfreien Versand';
      const progressText = rawTemplate
        .replace(/\{amount\}/g, `<strong>${remainingText}</strong>`)
        .replace(/\{\{\s*remaining\s*\}\}/g, `<strong>${remainingText}</strong>`);

      if (message) {
        if (remaining > 0) {
          message.innerHTML = progressText;
          this.classList.remove('is-eligible');
        } else {
          message.innerHTML = successText;
          this.classList.add('is-eligible');
        }
      }
    }

    _formatMoney(cents) {
      const format = (window.KROWN && window.KROWN.settings && window.KROWN.settings.shop_money_format) || '€{{amount_with_comma_separator}}';
      const value = cents / 100;
      const formatted = value.toFixed(2).replace('.', ',');
      return format.replace(/\{\{\s*amount[^}]*\}\}/, formatted);
    }
  }

  if (typeof customElements.get('olive-shipping-bar') === 'undefined') {
    customElements.define('olive-shipping-bar', OliveShippingBar);
  }
}
